import { ClaimMetric, Sentiment } from 'graphql/generated';
import { theme } from 'styles/theme';

export const getSentimentLabelBySentiment = (sentiment: Sentiment): string => {
  if (sentiment === Sentiment.Positive) {
    return 'Positive';
  }
  if (sentiment === Sentiment.Neutral) {
    return 'Neutral';
  }
  if (sentiment === Sentiment.Negative) {
    return 'Negative';
  }
  return '';
};

export type ClaimMetricWithSentiment = ClaimMetric & {
  sentiment: Sentiment;
};

export type ClaimMetricByAttribute = {
  attribute: string;
  sentiments: {
    sentiment: Sentiment;
    numberOfMentions: number;
  }[];
};

export type ClaimMetricEmoji = {
  emoji: string;
  bgColor: string;
};

export const getClaimMetricRandomEmoji = (index: number): ClaimMetricEmoji => {
  const fixedEmojiColor = [
    {
      emoji: '💲',
      bgColor: theme.colors?.utility['purple-1'],
    },
    {
      emoji: '😇',
      bgColor: theme.colors?.utility['teal-1'],
    },
    {
      emoji: '🌞',
      bgColor: theme.colors?.utility['orange-1'],
    },
    {
      emoji: '✔️',
      bgColor: theme.colors?.utility['teal-1'],
    },
    {
      emoji: '🔬',
      bgColor: theme.colors?.utility['yellow-1'],
    },
    {
      emoji: '🥴',
      bgColor: theme.colors?.utility['purple-1'],
    },
  ];
  const randomIndex = index % fixedEmojiColor.length;
  const randomEmoji = fixedEmojiColor[randomIndex] as ClaimMetricEmoji;
  return randomEmoji;
};

export const getColorBySentiment = (sentiment: Sentiment) => {
  switch (sentiment) {
    case Sentiment.Positive:
      return theme.colors?.utility['green-1'];
    case Sentiment.Neutral:
      return theme.colors?.utility['blue-1'];
    case Sentiment.Negative:
      return theme.colors?.utility['pink-1'];
    default:
      return theme.colors?.utility['purple-1'];
  }
};
